export default __webpack_public_path__ + "static/media/gallery09.8460d83f.jpg";